import script from "./MobileConvList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileConvList.vue?vue&type=script&setup=true&lang=ts"

import "./MobileConvList.vue?vue&type=style&index=0&id=59129261&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59129261"]])

export default __exports__